export type AssetsTab = 'room-assets' | 'inclusion-assets';

type InclusionAssetView = 'inclusion' | 'asset';

export const ROOM_ASSETS_TAB = 'room-assets';
export const INCLUSION_ASSETS_TAB = 'inclusion-assets';

const ASSETS_TABS: Array<AssetsTab> = [ROOM_ASSETS_TAB, INCLUSION_ASSETS_TAB];

export function getAssetsTab(tab: string | null | undefined): AssetsTab {
  return ASSETS_TABS.some((assetsTab) => assetsTab === tab) ? (tab as AssetsTab) : ROOM_ASSETS_TAB;
}

export function getInclusionAssetView(view: string | null | undefined): InclusionAssetView {
  return view === 'asset' ? 'asset' : 'inclusion';
}
